import React from 'react';
import './not-found.scss';

const NotFound = ({ message }: { message?: string }) => {
  return <div className="not-found">{message}</div>;
};

export default NotFound;
